import { render, staticRenderFns } from "./PetCTTraining.vue?vue&type=template&id=688e71be&"
import script from "./PetCTTraining.vue?vue&type=script&lang=js&"
export * from "./PetCTTraining.vue?vue&type=script&lang=js&"
import style0 from "./PetCTTraining.vue?vue&type=style&index=0&id=688e71be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports